import React from 'react';
import backgroun from './../../assets/images/abogados.jpg'
import { FaClipboardCheck, FaUserGraduate, FaSearch, FaChartLine, FaHeadset, FaClock } from 'react-icons/fa';

const benefits = [
  { icon: FaClipboardCheck, text: 'Exámenes diseñados estrictamente con base en los ejes temáticos oficiales.' },
  { icon: FaUserGraduate, text: 'Preguntas elaboradas por especialistas que ocupan u ocuparon el cargo al que postulas.' },
  { icon: FaSearch, text: 'Revisión de cada examen que des, pregunta por pregunta.' },
  { icon: FaChartLine, text: 'Gráficos que te indican tu progreso y en qué materias necesitas reforzar.' },
  { icon: FaHeadset, text: 'Soporte personalizado.' },
  { icon: FaClock, text: 'Disponibilidad 24/7.' },
];

export default function ContentParallax(){

    var sectionStyle = {
        width: "100%",
        background: "linear-gradient(rgba(34,35,40,0.72), rgba(34,35,40,0.82)), url("+backgroun+") fixed 50% 50%",
        backgroundSize: 'cover',
      };

    return(
    <>
     <div  style={sectionStyle} className="p-6 md:p-16 flex flex-row items-center">
         <div className="bg-white w-full md:w-3/5 lg:w-1/2 rounded-2xl p-6 md:p-10 shadow-2xl">
          <p className="text-primary text-sm font-bold uppercase tracking-widest">Por qué elegirnos</p>
          <h3 className="text-fondo text-3xl font-bold leading-relaxed mt-1">Beneficios Apriori</h3>
          <ul className="mt-4"> 
            {benefits.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.text} className="flex items-start mt-4 text-base md:text-lg text-gray-700">
                  <span className="text-primary mt-1 mr-3 flex-shrink-0"><Icon /></span>
                  <span>{item.text}</span>
                </li>
              );
            })}
          </ul>
         </div>
         
     </div>
    </>
    );
};
